import { tuple } from './type';
export const PresetStatusColorTypes = tuple('success', 'processing', 'error', 'default', 'warning');
export const PresetStatusTypes = tuple('inactive', 'active', 'processing', 'success', 'error', 'warning');
// eslint-disable-next-line import/prefer-default-export
export const PresetColorTypes = tuple('blue', 'red', 'green', 'orange', 'grey');
